// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","companyInfo":"Footer_companyInfo__hQvwl","logo":"Footer_logo__GkEml","links":"Footer_links__q2x7d"};